export default "__VITE_ASSET__U4e2WBu3__"